export default "/build/client/static/fonts/SoderbergSans-Bold.woff2";